/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { InternalAxiosRequestConfig } from 'axios';
import PubSub from 'pubsub-js';

import { PUB_SUB_APP_CHANNEL } from '../../constants/settings';
import { PubSubEvent, PubSubEvents } from '../../types/common/PubSubEvents';
import { jwtToken } from '../storageHelpers';

export const axiosJwtTokenInterceptor = (reqConfig: InternalAxiosRequestConfig) => {
  const jwt = jwtToken.get();
  if (jwt) {
    reqConfig.headers!.authorization = `Bearer ${jwt}`;
  }
  return reqConfig;
};

export const axiosUnauthorizedInterceptor = (error: any) => {
  if (error?.response?.status === 401) {
    const event: PubSubEvent<PubSubEvents> = {
      type: PubSubEvents.RequestUnauthorized,
      payload: {},
    };
    PubSub.publish(PUB_SUB_APP_CHANNEL, event);
  }
  return Promise.reject(error);
};
